import React from 'react';
import Hero from '../components/Home/Hero';
import NewsCard from '../components/Home/NewsCard';
import VideoCard from '../components/Home/VideoCard';
import Sidebar from '../components/Home/Sidebar';
import { useApp } from '../context/AppContext';
import JokesDisplay from '../components/Home/JokesDisplay';

const HomePage = () => {
    const { articles, videos, sections, loading } = useApp();

    if (loading) {
        return (
            <div className="loader">
                <div className="loader-spinner"></div>
            </div>
        );
    }

    const liveArticles = articles.filter(a => a.status === 'live');
    const featuredArticles = liveArticles.filter(a => a.featured === 'yes');
    const topStories = liveArticles.slice(0, 6);
    const politicsArticles = liveArticles.filter(a => a.category === 'Politics').slice(0, 4);
    const sportsArticles = liveArticles.filter(a => a.category === 'Sports').slice(0, 4);
    const entertainmentArticles = liveArticles.filter(a => a.category === 'Entertainment').slice(0, 3);
    const businessArticles = liveArticles.filter(a => a.category === 'Business').slice(0, 4);
    const technologyArticles = liveArticles.filter(a => a.category === 'Technology').slice(0, 4);
    const worldArticles = liveArticles.filter(a => a.category === 'World').slice(0, 4); // ✅ Added World section
    const featuredVideos = videos.filter(v => v.status === 'live' && v.featured === 'yes').slice(0, 4);
    const viralArticles = liveArticles.filter(a => a.category === 'Viral').slice(0, 4);
    const lifestyleArticles = liveArticles.filter(a => a.category === 'Lifestyle').slice(0, 4);
    const ajabGajabArticles = liveArticles.filter(a => a.category === 'Ajab Gajab').slice(0, 4);

    // Helper function to check if section is enabled
    const isSectionEnabled = (sectionId) => {
        const section = sections.find(s => s.id === sectionId);
        return section ? section.enabled === true : false;
    };

    return (
        <div className="page">
            {/* Hero Section - Only show if enabled */}
            {isSectionEnabled('hero') && (
                <Hero articles={liveArticles} featuredArticles={featuredArticles} />
            )}

            {/* Jokes Section - Fun addition! */}
            {isSectionEnabled('jokes') && <JokesDisplay />}

            {/* Top Stories + Sidebar - Only show if enabled */}
            {isSectionEnabled('top') && (
                <div className="two-col" style={{ marginTop: '28px' }}>
                    <div>
                        <div className="section-title">Top Stories</div>
                        <div className="three-col">
                            {topStories.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <a href="/category/india" className="btn btn-outline">View All India News →</a>
                        </div>
                    </div>
                    <div>
                        <Sidebar articles={liveArticles} />
                    </div>
                </div>
            )}

            {/* 🌍 World Section - NEW */}
            {isSectionEnabled('world') && worldArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>🌍 WORLD</div>
                            <a href="/category/world" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {worldArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Politics Section - Only show if enabled */}
            {isSectionEnabled('politics') && politicsArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>🏛 POLITICS</div>
                            <a href="/category/politics" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {politicsArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Sports Section - Only show if enabled */}
            {isSectionEnabled('sports') && sportsArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>🏏 SPORTS</div>
                            <a href="/category/sports" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {sportsArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Business Section - Only show if enabled */}
            {isSectionEnabled('business') && businessArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>💼 BUSINESS</div>
                            <a href="/category/business" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {businessArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Technology Section - Only show if enabled */}
            {isSectionEnabled('technology') && technologyArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>💻 TECHNOLOGY</div>
                            <a href="/category/technology" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {technologyArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Videos Section - Only show if enabled */}
            {isSectionEnabled('videos') && featuredVideos.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>📹 VIDEOS</div>
                            <a href="/videos" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {featuredVideos.map(video => (
                                <VideoCard key={video._id} video={video} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Entertainment Section - Only show if enabled */}
            {isSectionEnabled('entertainment') && entertainmentArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>🎬 ENTERTAINMENT</div>
                            <a href="/category/entertainment" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="three-col">
                            {entertainmentArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Viral Section - Only show if enabled */}
            {isSectionEnabled('viral') && viralArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>🔥 VIRAL</div>
                            <a href="/category/viral" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {viralArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Lifestyle Section - Only show if enabled */}
            {isSectionEnabled('lifestyle') && lifestyleArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>🌟 LIFESTYLE</div>
                            <a href="/category/lifestyle" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {lifestyleArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}

            {/* Ajab Gajab Section - Only show if enabled */}
            {isSectionEnabled('ajab-gajab') && ajabGajabArticles.length > 0 && (
                <>
                    <div className="section-band" style={{ background: 'var(--navy)', padding: '8px 0', margin: '28px 0 0' }}>
                        <div className="inner" style={{ maxWidth: '1280px', margin: 'auto', padding: '0 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div style={{ fontFamily: 'var(--ff-label)', letterSpacing: '2px', color: '#fff', fontSize: '18px' }}>🤯 AJAB GAJAB</div>
                            <a href="/category/ajab-gajab" style={{ color: '#aac', fontSize: '12px', fontWeight: '600' }}>See All →</a>
                        </div>
                    </div>
                    <div className="page" style={{ paddingTop: '20px', paddingBottom: '0' }}>
                        <div className="four-col">
                            {ajabGajabArticles.map(article => (
                                <NewsCard key={article._id} article={article} />
                            ))}
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default HomePage;